import { render, staticRenderFns } from "./ResBadgeHolderView.vue?vue&type=template&id=29cdc8ea&scoped=true"
import script from "./ResBadgeHolderView.vue?vue&type=script&lang=js"
export * from "./ResBadgeHolderView.vue?vue&type=script&lang=js"
import style0 from "./ResBadgeHolderView.vue?vue&type=style&index=0&id=29cdc8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cdc8ea",
  null
  
)

export default component.exports